/**
 * Backs a stable `FeatureFlagsContext` value. Replacing the context value re-rendered every flag
 * consumer on each readiness or context change; notifying lets each hook re-check its own result
 * and re-render only when that result changed.
 */
export function createFeatureFlagsPublisher(initial) {
    let current = initial;
    let version = 0;
    let notifiedVersion = 0;
    const listeners = new Set();
    const value = {
        get appliedEppoUserId() {
            return current.appliedEppoUserId;
        },
        get hasLoadedUserInfo() {
            return current.hasLoadedUserInfo;
        },
        get hasProcessedUrlOverrides() {
            return current.hasProcessedUrlOverrides;
        },
        getFlagOverride: (params) => current.getFlagOverride(params),
        getFlagValue: (params) => current.getFlagValue(params),
        getVersion: () => version,
        isOpenFeatureFlagReady: (flag) => current.isOpenFeatureFlagReady(flag),
        subscribe: (onChange) => {
            listeners.add(onChange);
            return () => {
                listeners.delete(onChange);
            };
        },
    };
    return {
        value,
        update: (snapshot) => {
            if (snapshot === current)
                return;
            current = snapshot;
            version += 1;
        },
        notify: () => {
            if (notifiedVersion === version)
                return;
            notifiedVersion = version;
            [...listeners].forEach((onChange) => onChange());
        },
    };
}
//# sourceMappingURL=featureFlagsPublisher.js.map